/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, SearchLinkField } from 'framework/ui/field';
import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';

type SkillBasedQueueSearchLinkFieldProps = {
  label?: string;
  idValue?: string;
  idSource?: string;
  source?: string;
  isSortable?: boolean;
  width?: number;
};

const SkillBasedQueueSearchLinkField = ({ idValue, idSource, ...props }: SkillBasedQueueSearchLinkFieldProps) => {
  const { getSingleEntityUrl } = useSkillBasedQueueUrl();
  const { getValue: getId } = useFieldHelper({ source: idSource, value: idValue });
  const { getValue } = useFieldHelper<any>(props);

  const id = getId();
  const name = getValue();

  return <SearchLinkField {...props} value={name} url={getSingleEntityUrl(id)} isRowClickable={false} />;
};

export default SkillBasedQueueSearchLinkField;
